module.exports = __webpack_public_path__ + "img/about-img5.0518394f.png";